<template>
  <v-dialog persistent v-model="dialog" max-width="800px">
    <template slot="activator">
      <slot>
        <v-btn
          fixed
          fab
          bottom
          right
          color="primary"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-card-title class="primary">
        <span class="headline white--text">Gastgeber hinzufügen</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field
                  label="Vorname"
                  v-model="host.forename"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Nachname"
                  v-model="host.surname"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Email"
                  required
                  v-model="host.email"
                  :rules="emailRules"
                  :disabled="loading"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="cancel()">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="save()">Erstellen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'DlgHostNew',
    data() {
      return {
        dialog: false,
        host: {},
        loading: false,
        valid: true,
        emailRules: [
          (v) => !!v || 'E-mail ist ein Pflichtfeld',
          (v) => /.+@.+/.test(v) || 'E-mail ist ungültig',
        ],
        genders: [
          {
            text: 'Weiblich',
            value: 'female',
          },
          {
            text: 'Männlich',
            value: 'male',
          },
        ],
      };
    },
    methods: {
      ...mapActions({
        createHost: 'admin/hosts/create',
        readHosts: 'admin/hosts/read',
      }),
      save() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.createHost(this.host).then((host) => {
            this.loading = false;
            if (host) {
              this.$emit('added', host);
              this.host = {};
              this.readHosts();
              this.dialog = false;
              this.valid = true;
            }
          });
        }
      },
      cancel() {
        this.dialog = false;
        this.host = {};
      },
    },
  };
</script>

<style scoped>

</style>
